import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'

const state = {
  dateRangeFrom: moment(new Date()).add(-100, 'year').format('DD.MM.YYYY'),
  dateRangeTo: moment(new Date()).format('DD.MM.YYYY'),
  isEdit: false,
  coverPhoto: null,
  activeTab: 'listing',
  isSideBarActive: false,
  toggleRightTab: false,
  tempPhotos: [],
  isDetailsTabActive: false,
  isMainViewActive: true,

  photoDetailsPage: false,
  onePhotoDetails: true,
  twoPhotosDetails: false,
  fourPhotosDetails: false,
  photoContentImages: [],

  showCoverPhoto: true,
  isImgFromPhotos: false,

  selectedImages: [],
  photoDocuments: [],
  preportTemplates: [],
  templatesCopy: [],
  isLoading: true,
  currentLockState: false,
  // Api meta data of template
  selectedTemplate: {
    basics: {
      show_left_logo: '1',
      show_right_logo: '1',
      background_id: '0',
      show_footer: '1',
      show_logos: '1'
    },
    cover: {
      decoimage_id: '',
      show_cover: '1',
      show_cover_from_decoimage: '1',
      show_project_details: {
        creation_date: '1',
        creator: '1',
        name: '1',
        number: '1',
        responsible: '1',
        start: '1'
      }
    },
    photopages: {
      photolayout: '1',
      photo_layout_settings: {
        show_date: '1',
        show_description: '1',
        show_photo_id: '1',
        show_plan_clip: '1',
        show_tags: '1'
      }
    },
    textpages: {
      after_cover: '0',
      after_photos: '1',
      after_plans: '1'
    }
  },

  dailyReportPhotos: [],

  documentPagesInfo: {
    pages: [{
      type: 'Coverpage',
      // text page one heading
      content: [
        {
          'content': '<h1>Heading One</h1>',
          'settings': ''
        },
        {
          'content': '<h1>Heading Two</h1>',
          'settings': ''
        },
        {
          'content': '<h1>Heading Three</h1>',
          'settings': ''
        }
      ]
    }, {
      type: 'Textpage',
      content: [
        {
          'content': '<h1>Text page heading</h1>',
          'settings': ''
        },
        {
          'content': '<p>Text Page Description</p>',
          'settings': ''
        }
      ]
    },
    {
      type: 'Photopage',
      content: [
        {
          'photoids': [
            // 12 , 14
          ],
          'settings': ''
        },
        {
          'phototext': {
            // photo description. Key as photo ID, value as text
            // 12 : "description of photo id 12",
            // 14 : "description of photo id 14",
          }
        }
      ]
    }

    ]},

  // All content of cover page
  coverPageContent: {
    type: 'Coverpage',
    contents: [
      {
        content: '<h2>Fotodokumentation</h2>',
        settings: ''
      },
      {
        content: '<h3>Projekt Flurdoku 912</h3>',
        settings: ''
      },
      {
        content: '<h3>Flurdoku 912 </h3>',
        settings: ''
      }
    ]
  },

  // Textarea One Content
  textPageOneContent: {
    type: 'Textpage',
    contents: [
      {
        content: `<h2> Text Page Heading </h2>`,
        settings: ''
      },
      {
        content: '',
        settings: ''
      }
    ]
  },

  // Textarea Two Content
  textPageTwoContent: {
    type: 'Textpage',
    contents: [
      {
        content: `<h2> Text Page Heading </h2>`,
        settings: ''
      },
      {
        content: '',
        settings: ''
      }
    ]
  },
  // Photos Content ( Ids and photos description with ids )
  photosContent: {
    type: 'Photopage',
    contents: [
      {
        photoids: [
          // 12 , 14
        ],
        settings: ''
      },
      {
        phototext: {
          // photo description. Key as photo ID, value as text
          // 12 : "description of photo id 12",
          // 14 : "description of photo id 14",
        }
      }
    ]
  },

  // for store Information about Selected Document
  selectedDocument: {reportparams: {}},

  // Params for get docs list
  params: {
    id: null,
    filters: {
      filterparams: {
        searchstring: '',
        date_from: '',
        date_to: '',
        tags: '',
        clearance: '',
        creator_ids: []
      },
      start: 0,
      perpage: 10
    }
  },

  photoInDoument :{
    pdphotoid: 2309,
    pdphototext: "",
    pdreportid: null,
    pdreportitemid: null,
    _explicitType: "com\\projectdocu\\PDReportItemVO"
  },

  documentDetails : {
    pdreportid: "0",//will be 0 if new report
    creator: 0,
    decoimage: "0",
    description: "",
    incplan: true,
    line1: "Line One",
    line2: "Line two",
    line3: "",
    line4: "",
    locked: false,
    prevLockState: false,
    pdreportitems: [],
    planitems: [],
    projectid: '',
    reportdate: "",
    reportname: "Report Name",
    reporttype: "0", //in case of special report it will be 1
    reporturl: "/backend/get?method=report&rid=57",
    reportparams: {
      singlephotopage: 0,
      smallplandots: 0
    },
    revision: "0",
    status: 1,
    time: "",
    generated: true,
    _explicitType: "com\\projectdocu\\PDReportVO"
  },

  //For create new document
  newDocumentDetails: {
    pdreportid: "0",
    creator: 'Andre Henniger',
    decoimage: "0",
    description: "",
    incplan: true,
    line1: "Line One",
    line2: "Line two",
    locked: false,
    prevLockState: false,
    pdreportitems: [],
    pduserid: "1",
    planitems: [],
    projectid: '',
    reportdate: null,
    reportname: "",
    reporttype: false,
    reporturl: "/backend/get?method=report&rid=57",
    reportparams: {
      singlephotopage: 0,
      smallplandots: 0
    },
    revision: "0",
    status: 1,
    time: "",
    _explicitType: "com\\projectdocu\\ReportVO"
  },

  photoDocsMeta: {maxcount: null},


  dailyReportDate:'',

  documentDetailsCopy: {
    pdreportid: "0",
    creator: 'Andre Henniger',
    decoimage: "0",
    description: "",
    incplan: false,
    line1: "Line One",
    line2: "Line two",
    locked: false,
    prevLockState: false,
    pdreportitems: [],
    pduserid: "1",
    planitems: [],
    projectid: '',
    reportdate: null,
    reportname: "",
    reporttype: false,
    reporturl: "/backend/get?method=report&rid=57",
    reportparams: {
      singlephotopage: '0',
      smallplandots: '0'
    },
    revision: "0",
    status: 1,
    time: "",
    isloading: false,
    _explicitType: "com\\projectdocu\\ReportVO"
  },

  photoDocsMinimumDate: null,
  photoDocsMaximumDate: null
}

const getters = {
  getActiveTabNav: state => state.activeTab,
  getDailyReportPhotos : state => state.dailyReportPhotos,
  getSpecialReportPhotos : state => state.selectedImages,
  getPhotoContentImages : state => state.photoContentImages
}

const mutations = {
  setDailyReportPhotos: (state, payload)=> {
    (Array.isArray(payload)) ? state.dailyReportPhotos = payload : state.dailyReportPhotos.push(payload);
  },

  setForNewDocument: (state , payload) => {
    state.newDocumentDetails = JSON.parse(JSON.stringify(payload))
  },

  setDailyReportDate: (state, payload) => state.dailyReportDate = payload,

  setDocumentDetailsCopy: (state, payload) => state.documentDetailsCopy = payload,

  setDocumentDetails: (state, payload) => state.documentDetails = payload,

  setPhotoContentImages: (state, payload) => {
    if (Array.isArray(payload)){
      state.photoContentImages = payload
    }else {
      state.photoContentImages.push(payload)
    }
  },

  setDateRangeFrom: (state, payload) => {
    state.params.filters.filterparams.date_from = payload
    state.dateRangeFrom = payload
  },

  setDateRangeTo: (state, payload) => {
    state.params.filters.filterparams.date_to = payload
    state.dateRangeTo = payload
  },

  setPhotoDocuments: (state, payload) => {
    state.photoDocuments = payload
  },

  setSearchString: (state, payload) => {
    state.params.filters.filterparams.searchstring = payload
  },

  setTemplates: (state, payload) => {
    state.preportTemplates = payload
    state.templatesCopy = payload
  },

  changeTab (state, currentTab) {
    state.activeTab = currentTab
  },

  toggleSideNav: (state, value) => {
    state.isSideBarActive = value
  },

  setPhotoDocsMeta: (state , val) => (state.photoDocsMeta = val),
  setPhotoDocsMetaDateFrom: (state , val) => (state.photoDocsMinimumDate = val),
  setPhotoDocsMetaDateTo: (state , val) => (state.photoDocsMaximumDate = val),
  toggleRightTab: (state, value) => {state.toggleRightTab = value},
  toggleDetailsTab: (state, value) => {state.isDetailsTabActive = value},
  toggleMainDetailsTab: (state, value) => {state.isMainViewActive = value},
  setSelectedImages: (state, payload) => {state.selectedImages = payload},
  setTempPhotos: (state, payload) => { state.tempPhotos = payload },
  pushInTempPhotos: (state, payload) => { state.tempPhotos.push(payload) },
  resetPhotoDocument: (state, payload = []) => {
    state.selectedImages = payload
    state.tempPhotos = payload
  },
  pushInSelectedImages: (state, payload) => {
    state.selectedImages.push(payload);
  },

  unSelectImage: (state, index) => {
    state.selectedImages.splice(index, 1)
    state.tempPhotos.splice(index, 1)
  },

  emptySelectedImages: (state, index) => {
    state.selectedImages = []
  },

  setTemplate: (state, payload) => {
    state.selectedTemplate = payload
  },

  activePhotoDetailsPage: (state, payload) => {
    state.photoDetailsPage = payload
  },
  activeOnePhoto: (state, payload) => {
    state.onePhotoDetails = payload
  },
  activeTwoPhotos: (state, payload) => {
    state.twoPhotosDetails = payload
  },
  activeFourPhotos: (state, payload) => {
    state.fourPhotosDetails = payload
  },

  toggleCoverPhoto: (state, payload) => {
    state.showCoverPhoto = payload
  },
  setCoverPhoto: (state, payload) => {
    state.coverPhoto = payload
  },
  isImgFromPhotos: (state, payload) => {
    state.isImgFromPhotos = payload
  },
  setCoverImageId: (state, payload) => {
    state.photoDocumentation.selectedTemplate.cover.decoimage_id = payload
  },
  toggleLoading: (state, payload) => {
    state.isLoading = payload
  },
  setIsEditDocsModule : (state, payload) => {
    state.isEdit = payload
  },

  setSelectedDocument: (state, payload) => {
    state.selectedDocument = payload
  },

  //set the document to data for saving or update
  setAllDocumentData: (state,id) => {
    state.newDocumentDetails.projectid = id;
    state.newDocumentDetails.pdreportitems = [];

    if (state.newDocumentDetails.reporttype === '0'){
      state.dailyReportPhotos.map(item => {
        let photo = {
          pdphotoid: item.pdphotoid,
          pdphototext: item.description,
          pdreportid: 0,
          pdreportitemid: 0,
          _explicitType: "com\\projectdocu\\PDReportItemVO"
        }
        state.newDocumentDetails.pdreportitems.push(photo)
      });
    } else {
      state.selectedImages.map(item => {
          let photo = {
            pdphotoid: item.pdphotoid,
            pdphototext: item.pdphototext,
            pdreportid: 0,
            pdreportitemid: 0,
            _explicitType: "com\\projectdocu\\PDReportItemVO"
          }
          state.newDocumentDetails.pdreportitems.push(photo)
      });
    }
  },

  setParamsForUpdateSpecialReport( state , id){
    state.selectedDocument.projectid = id;
    state.selectedDocument.pdreportitems = [];
    state.selectedImages.map(item => {
      let photo = {
        pdphotoid: item.pdphotoid,
        pdphototext: item.pdphototext,
        pdreportid: 0,
        pdreportitemid: 0,
        _explicitType: "com\\projectdocu\\PDReportItemVO"
      }
      state.selectedDocument.pdreportitems.push(photo)
    });
  }

}

const actions = {

  // Get Documents Lists
  async getPhotoDocsList({commit,dispatch},params){

    // console.log('documentation - fetch Documents getPhotoDocsList', params)
    commit('toggleLoading',true);
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getDefaultReportsOfProject",
        "parameters": params,
        "serviceName": "ProjectdocuService"
      },
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
      if (res.statusText === "OK" || res.status === 200){
        const docs = res.data.reports ? res.data.reports : [];
        const meta = res.data.meta;
        if (meta.maximumDate){
          meta.maximumDate = moment(meta.maximumDate).format('DD.MM.YYYY')
          meta.minimumDate = moment(meta.minimumDate).format('DD.MM.YYYY')
          state.minimumDate = meta.minimumDate;
          state.maximumDate = meta.maximumDate;
        }
        commit('setPhotoDocsMeta', meta)
        commit('setPhotoDocuments', docs)
        commit('toggleLoading',false)
      }
    }).catch(error => {
      commit('settingsModuleSetLoading',false);
      commit('toggleLoading',false)
    })
  },

  // Get Templates
  async getTemplates ({commit}, id) {
    await axios.post(process.env.VUE_APP_BASE_URL + 'project/' + id + '/preport/gettemplates',
      { }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: 'string',
          accept: 'application/json'
        }
      }
    ).then(response => {
      let templates = response.data.data.tpls
      commit('setTemplates', templates)
    }).catch(e => {
      console.log(e)
    })
  },

  // Save Templates
  async saveTemplate ({dispatch, state, commit}, payload) {
    commit('toggleLoading', true)
    let data = { title: payload.title, tpl: state.selectedTemplate}
    await axios.post(`${process.env.VUE_APP_BASE_URL}/project/${payload.id}/preport/savetemplate`,
      data, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: 'string',
          accept: 'application/json'
        }
      }
    ).then(response => {
      if (response.status === 200) {
        this._vm.$toast.success('New Template Saved..!')
        dispatch('getTemplates', payload.id)
        commit('toggleLoading', false)
      } else if (response.status === 204) {
        this._vm.$toast.error('Oops . Some data are missing..!')
        commit('toggleLoading', false)
      }
    }).catch(e => {
      commit('toggleLoading', false)
      this._vm.$toast.error('Oops ... Something went wrong !')
    })
  },

   // Main Function For Save the Document
   async saveDocument ({commit, dispatch,state , getters}, payload) {
    commit('toggleLoading', true)
    let params = [];
    let report_type = state.newDocumentDetails.reporttype === "0" ? "createDailyReport": "createSpecialReport"
    if (state.newDocumentDetails.reporttype == "0"){
      await commit('setAllDocumentData',payload.id);
      params = [state.newDocumentDetails,state.dailyReportDate]
    }else {
      await commit('setAllDocumentData',payload.id);
      const photoelements = state.selectedImages
      photoelements.forEach((value, index) => {
        delete photoelements[index].src
      })
      params = [state.newDocumentDetails, photoelements]
      // params = [state.newDocumentDetails, getters.getSpecialReportPhotos]
    }


     console.log('SaveDocument', report_type, params)


    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": report_type,
        "serviceName": 'ProjectdocuService',
        "parameters": params
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
      if (response.status === 200) {
        this._vm.$toast.success('Fotodokumentation wurde gespeichert');
        commit('setForNewDocument' , state.documentDetailsCopy);
      } else if (response.status === 204) {
        this._vm.$toast.error('Oops . Some data are missing..!')
      }
      commit('resetPhotoDocument', []);
    }).catch(e => {
      this._vm.$toast.error(`Oops ... Something went wrong !`)
    })
     commit('toggleLoading', false);
  },



  async setGenerateStateToDocument({commit, dispatch,state}, payload) {
    // LALELU
      console.log('Document generate Status set!')

    let params = [state.selectedDocument, {}]
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        'methodName': 'setReportGenerated',
        'serviceName': 'ProjectdocuReports',
        'parameters': params
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
      if (response.status === 200) {
        // this._vm.$toast.success('Fotodokumentation wurde gespeichert')
      } else if (response.status === 204) {
        this._vm.$toast.error('Oops . Some data is missing..!')
      }
    }).catch(e => {
      this._vm.$toast.error(`Oops ... Something went wrong !`)
    })


  },
  // Main Function For Save the Document
  async updatePhotoDocument ({commit, dispatch,state}, payload) {
    commit('toggleLoading', true)
    console.log('UpdatePhotoDocument Commit', commit)
    console.log('UpdatePhotoDocument dispatch', dispatch)
    console.log('UpdatePhotoDocument state', state)
    console.log('UpdatePhotoDocument payload', payload)
    console.log('UpdatePhotoDocument state.documentDetailsCopy', state.documentDetailsCopy)
    console.log('UpdatePhotoDocument state.documentDetails', state.documentDetails)
    console.log('UpdatePhotoDocument state.newDocumentDetails', state.newDocumentDetails)
    console.log('UpdatePhotoDocument state.selectedDocument', state.selectedDocument)


    let params = [];
    let report_type = state.selectedDocument.reporttype === "0" ? "createDailyReport": "createSpecialReport"
    if (state.selectedDocument.reporttype === "0") {
      // Default Report
      await commit('setAllDocumentData', payload.id);
      params = [state.selectedDocument, state.dailyReportDate]
    } else {
      // Special Report
      await commit('setParamsForUpdateSpecialReport',payload.id);
      const photoelements = state.selectedImages;
      photoelements.forEach((value, index) => {
        delete photoelements[index].src
      });
      params = [state.selectedDocument, photoelements]
    }

    console.log('Before Params Set', {
        'selectedDocument': state.selectedDocument,
        'DetailsCopy.pdreportid': state.documentDetailsCopy.pdreportid,
        'DetailsCopy.locked': state.documentDetailsCopy.locked,
        'Params': params
      }
    )
    // if(state.selectedDocument.pdreportid != 0 && state.selectedDocument.locked === true) {
    if(state.selectedDocument.pdreportid != 0 && state.selectedDocument.prevLockState === true) {
      // this.$store.state.photoDocuments.currentLockState

      params[0].locked = false
      params[0].revision = (parseInt(params[0].revision) + 1).toString()
      params[0].pdreportid = 0
      params[0].pduserid = payload.currentuserid
      params[0].creator = payload.currentusername

      console.log('After Params Set', params)

    }


console.log('documentation - Send Awaited Updated Call')
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": report_type,
        "serviceName": 'ProjectdocuService',
        "parameters": params
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
      if (response.status === 200) {
        this._vm.$toast.success('Fotodokumentation wurde gespeichert')
      } else if (response.status === 204) {
        this._vm.$toast.error('Oops . Some data is missing..!')
      }

      commit('resetPhotoDocument',[])

      // let docindex = state.photoDocuments.findIndex((docl) => docl.pdreportid == payload.id)
      // state.photoDocuments[docindex].isloading = false

      console.log('Report Finaly Saved!', {'PayLoadId': payload.id, 'SelectedDocument': state.selectedDocument, 'documents': state.photoDocuments})
    }).catch(e => {
      this._vm.$toast.error(`Oops ... Something went wrong !`)
    })
    commit('toggleLoading', false);
  },



  // Set Cover Image
  async setCoverImage ({commit}, imgId) {
    await fetch(`${process.env.VUE_APP_BASE_URL}/getfile/photo/${imgId}/650*550/13:11`,
       {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: 'string'
        }
      })
      .then(response => response.blob())
      .then(response => {
        let reader = new FileReader()
        reader.readAsDataURL(response)
        reader.onload = function () {
          commit('setCoverPhoto', reader.result)
          commit('setCoverPhotoId', imgId)
        }
      }).catch((error) => {
        console.error('Error:', error)
      })
  },


  // =======================OLD APIs METHODS ===================

  // get images Details by ids
  async getImagesByIdsDocsModule({dispatch,commit},photoParams) {
    commit('toggleLoading',true);
    commit("setPhotoContentImages",[]);
    commit("setTempPhotos",[]);
    let prm = {}
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "getPhotosOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": photoParams.ids
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        prm = { photos: response.data.photos , items : photoParams.items}
    }).catch(e => {
      console.log(e)
    });
    await dispatch('getImagesFilesDocsModule',prm)
    commit('toggleLoading',false)
  },

  //Get Photo Files
  async getFilesDocsModule ({commit},photo) {
    commit('settingsModuleSetLoading',true);
    await fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${photo.projectid}&id=${photo.pdphotoid}&token=${localStorage.sessiontoken}`,
      {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
        }
      }
    ).then(response => response.blob())
      .then(response => {
        let reader = new FileReader()
        reader.readAsDataURL(response)
        reader.onload = function () {
          photo.src = reader.result
          commit("setPhotoContentImages" ,photo);
          commit("pushInTempPhotos" ,photo);
          commit("pushInSelectedImages" ,photo);
        }
      }).catch(error =>{
        console.log(error);
      });
    return photo;
  },

  //This function get all the
  async getImagesFilesDocsModule({commit, dispatch, state }, payload) {
    commit( 'toggleLoading', true )
    commit("setSelectedImages", [] );
    for ( let i = 0; i < payload.photos.length; i++ ) {
      let photo = payload.photos[i];
      console.log('For Photo in List', photo)
      commit( 'toggleLoading', true )
      const docItem =  payload.items.find(img => img.pdphotoid === photo.pdphotoid);
      const image = {
        pdphotoid: photo.pdphotoid,
        pdphototext: photo.description,
        description: photo.description,
        pduserid: photo.pduserid,
        runid: photo.runid,
        projectid: photo.projectid,
        photodate: photo.photodate,
        params: photo.params,
        origname: photo.origname,
        phototype: photo.phototype
      }
      const imageCopy = {...image}
      imageCopy.pdphototext = docItem ? docItem.pdphototext : '';
      commit("pushInTempPhotos" ,image);
      commit("setPhotoContentImages" ,imageCopy);
      commit("pushInSelectedImages" ,imageCopy);

      // await fetch(photo_url, {
      //     headers: {
      //       apitoken: localStorage.apikey,
      //       deviceid: localStorage.deviceid,
      //     }
      //   }).then(response => response.blob())
      //   .then(response => {
      //     let reader = new FileReader();
      //     reader.readAsDataURL(response)
      //     reader.onload = function () {
      //       photo.src = reader.result
      //     }
      //   }).catch(error =>{
      //     console.log(error);
      //   });
    }
    commit('toggleLoading',false)
  },

  async deletePhotoDocument({ commit }, id) {
    commit( 'toggleLoading', true )
    await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
      {
        "methodName": "deleteReport",
        "serviceName": "ProjectdocuService",
        "parameters": [id]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(res => {
        if (res.status === 200 || res.statusText === 'OK'){
          this._vm.$toast.success('Fotodokumentation gelöscht')
        }
    })
    commit( 'toggleLoading', false )
  },

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/photoDocumentation.js